(() => {
  'use strict';
  const fallback = image => {
    if (!image.getAttribute('src') && !image.getAttribute('srcset')) return;
    if (image.closest('[data-demo-profile],[data-public-profile],[data-achievement-list]')) return;
    if (image.dataset.fallbackHandled) return;
    image.dataset.fallbackHandled = 'true';
    const text = document.createElement('span');
    text.dataset.imageFailed = 'true';
    if (image.alt) { text.textContent = image.alt; text.setAttribute('role','img'); text.setAttribute('aria-label',image.alt); }
    else text.setAttribute('aria-hidden','true');
    image.replaceWith(text);
  };
  document.addEventListener('error',event=>{if(event.target instanceof HTMLImageElement) fallback(event.target);},true);
  document.querySelectorAll('img').forEach(img=>{if(img.complete&&!img.naturalWidth) fallback(img);});
})();
